const giftFunction = (() => {
	console.log('gift Function');

	// Declaring Variables
	const allCheckbox = [...document.querySelectorAll('.gift_checkbox')];
	const updateCart = document.getElementById('update-cart');
	const allInputs = [...document.querySelectorAll('.input--regalo')];
	const checkoutBtns = [...document.querySelectorAll('button[name="checkout"]')];
	const cartForm = document.getElementById('cart_form');
  const popupBigContainer    = document.createElement('div');
  const popupContainer       = document.createElement('div');
  const popupTitleContainer  = document.createElement('div');
  const popupTitleSpan       = document.createElement('span');
  const popupSelectContainer = document.createElement('div');
  const popupSelectThemeContainer = document.createElement('div');
  const paperSelect          = document.createElement('select');
  const paperButton          = document.createElement('button');
  const OPT_DEFAULT          = `<option disabeld selected>Selecciona tu envoltorio</option>`;
  const OPT_LOADING          = `<option disabeld selected>Cargando...</option>`;
  const isMobile             = ( window.innerWidth > 425 ) ? false : true;
  const API_URL = 'https://innovateshopifyapps.com/inverfin-test/v1/creative/get-wrapper-by-sku'

  popupBigContainer.classList.add('PopupBigContainer')
  popupTitleContainer.classList.add('PopupTitleContainer')
  popupTitleSpan.classList.add('PopupGiftTitle')
  popupContainer.classList.add('PopupGiftContainer')
  popupSelectContainer.classList.add('PopupGiftContentContainer')
  popupSelectThemeContainer.classList.add('select-wrapper', 'select-wrapper--primary')
  paperButton.classList.add('button', 'button--primary')
  if ( isMobile ) {
    popupSelectThemeContainer.style.width = '75%'
    popupSelectThemeContainer.style.width = '80%'
  } else {
    paperButton.style.marginLeft = '5%'
    popupSelectThemeContainer.style.width = '50%'
  }
  popupSelectThemeContainer.innerHTML = '<svg viewBox="0 0 12 8" role="presentation" class="icon icon--arrow-bottom"><path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path></svg>'

  popupTitleSpan.textContent = 'Elige el envoltorio para tu regalo debajo: ↓'
  paperSelect.innerHTML = OPT_DEFAULT

  popupBigContainer.appendChild(popupContainer)
  popupTitleContainer.appendChild(popupTitleSpan)
  popupSelectThemeContainer.appendChild(paperSelect)
  popupSelectContainer.appendChild(popupSelectThemeContainer)
  popupSelectContainer.appendChild(paperButton)
  popupContainer.appendChild(popupTitleContainer)
  popupContainer.appendChild(popupSelectContainer)

  document.body.prepend(popupBigContainer)


	// Listeners

  paperButton.addEventListener('click', (evt) => {
    evt.preventDefault()
    
    if ( paperSelect.selectedIndex != 0 ) {
      buttonState( false, evt.target )
      let paperOption = paperSelect.selectedOptions[0]
      let varId = paperSelect.dataset.variantId
      let itemKey = paperSelect.dataset.key

      updateProperties( { key: itemKey, varId: varId }, { id: paperOption.id, description: paperOption.textContent }, ( response ) => {
        if ( response !== 'Error' ) {
          $(popupBigContainer).fadeOut()
          reBuildCart( varId )
        }
      })
    }
  })

  allCheckbox.forEach( (check, index) => {
    check.addEventListener('change', (evt) => {
      console.log(evt.target.checked)
      
      let skuElem = evt.target.dataset.sku
      // let skuElem = 'AFE.BAY.KIT.TRI'
      let varId = evt.target.dataset.variantId
      let itemKey = evt.target.dataset.key
      let qty = evt.target.parentElement.nextElementSibling.querySelector('.quantity-selector__value').value
      if ( evt.target.checked ) {
        paperSelect.innerHTML = OPT_LOADING
        paperSelect.dataset.variantId = varId
        paperSelect.dataset.key = itemKey
        buttonState( false, paperButton )

        // popupBigContainer.style.display = 'flex';

        getGiftPaper( skuElem, (papers) => {
          if ( papers !== 'Error' ) {
            buttonState( true, paperButton )
            console.log(papers)
            // let paperOptions = ''
            let objPaper = papers['a:TiposEnvoltorioEC']
            if ( !Array.isArray( objPaper ) ) objPaper = [objPaper]

            const { ['a:Descripcion']: descriptionPaper, ['a:ID']: idPaper, ['a:Articulo_ID']: artId } = objPaper[0]

            // objPaper.forEach( paper => {
            //   const { ['a:Descripcion']: descriptionPaper, ['a:ID']: idPaper, ['a:Articulo_ID']: artId } = paper
            //   paperOptions += `<option id="${idPaper}" data-article-id="${artId}">${descriptionPaper}</option>`
            // })

            // paperSelect.innerHTML = OPT_DEFAULT + paperOptions

            check.insertAdjacentHTML('afterend', `<input type="hidden" class="hiddenData-${varId}" data-name="EnvoltorioId" data-info="${idPaper}" />`)

            updateProperties( { key: itemKey, varId: varId }, { id: idPaper, description: descriptionPaper }, ( response ) => {
              if ( response !== 'Error' ) {
                // $(popupBigContainer).fadeOut()
                reBuildCart( varId )
              }
            })
          } else {
            popupContainer.innerHTML = '<span class="errorGift">Lo sentimos, no podemos mostrarle envoltorios para su regalo debido a problemas en el servidor.</span>'
            setTimeout(() => { popupBigContainer.style.display = 'none' }, 1500)
          }
        })
      } else {
        // Remove property
        updateProperties( { key: itemKey, varId: varId, qty: qty }, null, ( response ) => {
          console.log('item erased')
          if ( response !== 'Error while adding' ) {
            console.log(response)
            reBuildCart( varId )
          }
        })

        if ( document.querySelectorAll(`.hiddenData-${varId}`) ) document.querySelectorAll(`.hiddenData-${varId}`).remove()
      }
    })
  })
  
  checkoutBtns.forEach( btn => {
    btn.addEventListener('click', (evt) => {

      let objLS = {
        "regalos": []
      }

      allInputs.forEach( input => {
        if ( input.value != '' ) {
          let newObj = {
            [`${input.id}`]: `${input.value}`
          }
          objLS["regalos"].push(newObj);
        }
      })

      localStorage.setItem('regalos', JSON.stringify(objLS));

    })
  });

  function buttonState( status, btn ) {
    if ( status === true ) {
      btn.disabled = false
      btn.textContent = 'Seleccionar'
      btn.classList.remove('button--disabled')
    } else {
      btn.disabled = true
      btn.textContent = 'Cargando...'
      btn.classList.add('button--disabled')
    }
  }
  
  async function getGiftPaper( SKU, callback ) {
    try {
      let getPapers = await ( await fetch(API_URL + '?sku=' + SKU) ).json()
      callback( getPapers )
    } catch ( err ) {
      callback( 'Error' )
    }
  }

  async function updateProperties( itemData, paperData, callback ) {
    let payload = { 'id': itemData.key }

    let [...propertiesElements] = document.querySelectorAll(`.line-item__property[data-key="${itemData.key}"]`)
    let lineItemEl = propertiesElements.filter( elem => elem.getAttribute('cuota') === 'true' )

    payload = ( paperData === null ) 
              ? { ...payload, ...{'quantity': 0} } 
              : ( lineItemEl.length > 0 ) 
                ? { ...payload, ...{'properties': { [lineItemEl[0].dataset.name]: lineItemEl[0].dataset.info, 'Regalo': true, 'EnvoltorioId': paperData.id, 'TipoEnvoltorio': paperData.description }} }
                : { ...payload, ...{'properties': { 'Regalo': true, 'EnvoltorioId': paperData.id, 'TipoEnvoltorio': paperData.description }} }

    let configRequest = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }

    try {
      let apiRequest = await ( await fetch('/cart/change.js', configRequest) ).json()
      if ( paperData === null ) {
        let cuotaInfo = ( lineItemEl.length > 0 ) ? lineItemEl : null

        addToCart( itemData.varId, itemData.qty, cuotaInfo, (response) => {
          if ( response != 'Error' ) callback(response)
          else callback('Error while adding')
        })
      } else {
        callback( apiRequest )
      }
    } catch ( err ) {
      callback( 'Error while changing' )
    }
  }
  
  async function addToCart( varId, qty, cuotaInfo, callback ) {
    let payload = ( cuotaInfo === null ) 
                  ? { id: varId, quantity: qty }
                  : { id: varId, quantity: qty, properties: { 'CuotaPlan': cuotaInfo[0].dataset.info } }

    let configRequest = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }
    try {
      let apiRequest = await ( await fetch('/cart/add.js', configRequest) ).json()
      callback( apiRequest )
    } catch ( err ) {
      callback( 'Error' )
    }
  }

  function reBuildCart( varId ) {
    fetch(location.pathname)
    .then( res => res.text())
    .then(res => {
      $(`.line-item__meta[data-meta-id="${varId}"]`).html($(res).find(`.line-item__meta[data-meta-id="${varId}"]`).html())
      document.querySelector(`.gift_checkbox[data-variant-id="${varId}"]`).dataset.key = $(res).find(`.line-item__meta[data-meta-id="${varId}"]`).attr('data-key')
    })
  }
  
})()


